<template>
  <div class="Api">
      <a-select :value="provinName" style="width: 140px;height:30px;margin-right:18px;" @change="handleChange">
        <a-select-option :value="item.cityName" :index="index" :cityCode="item.cityCode" v-for="(item, index) in provinceArray" :key="index">
          {{item.cityName}}
        </a-select-option>
      </a-select>
      <a-select :value="cityName" style="width: 140px;height:30px;margin-right:18px;" @change="cityHandleChange">
        <a-select-option :value="item.cityName" :index="index" :cityCode="item.cityCode" v-for="(item, index) in cityArray" :key="index">
          {{item.cityName}}
        </a-select-option>
      </a-select>
      <a-select :value="areaName" style="width: 140px;height:30px;margin-right:18px;" @change="areaHandleChange">
        <a-select-option :value="item.cityName" :index="index" :cityCode="item.cityCode" v-for="(item, index) in areaArray" :key="index">
          {{item.cityName}}
        </a-select-option>
      </a-select>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

import { SsoGetCityInfo, SsogetCityInfoByAreaCode } from '@/api/login'
import { openNotificationWithIcon } from '@/utils/util'

export default {
  name: 'InterDiary',
  props: ['regiono'],
  data () {
    return {
      provinName: this.$t('credentials_请选择省'),
      cityName: this.$t('credentials_请选择市'),
      areaName: this.$t('credentials_请选择区'),
      provinceArray: [],
      cityArray: [],
      areaArray: [],
      provinCode: '',
      cityedCode: '',
      areaCode: '',
      vdArryres: []
    }
  },
  components: {
    // VDistpicker
  },
  computed: {
  },
  watch: {
    'regiono.provinCode': {
      handler: function (val) {
        if (!val) {
          this.provinName = '请选择省'
          this.cityName = '请选择市'
          this.areaName = '请选择区'
          this.provinCode = ''
          this.cityedCode = ''
          this.areaCode = ''
          return false
        }
        SsogetCityInfoByAreaCode(this.regiono.areaCode).then((res) => {
          if (res.code === '200') {
            if (res.data) {
              this.vdArryres = res.data.split('-')
              this.provinName = this.vdArryres[0]
              this.cityName = this.vdArryres[1]
              this.areaName = this.vdArryres[2]
              this.provinCode = this.regiono.provinCode
              this.cityedCode = this.regiono.cityedCode
              this.areaCode = this.regiono.areaCode
              const region = {
                provinName: this.provinName,
                cityName: this.cityName,
                areaName: this.areaName,
                provinCode: this.provinCode,
                cityedCode: this.cityedCode,
                areaCode: this.areaCode
              }
              this.$emit('setAddress', region)
            }
            // this.provinceArray.push({ cityName: this.vdArryres[0], cityCode: this.regiono.provinCode })
            // this.cityArray.push({ cityName: this.vdArryres[1], cityCode: this.regiono.cityedCode })
            // this.areaArray.push({ cityName: this.vdArryres[2], cityCode: this.regiono.areaCode })
          } else if (res.code !== '200') {
            openNotificationWithIcon(res.message)
          }
        })
      },
      immediate: true
    }
  },
  mounted () {
    // 获取省份
    SsoGetCityInfo({ cityScope: 'province' }).then((res) => {
      if (res.code === '200') {
        this.provinceArray = res.data
      } else if (res.code !== '200') {
        openNotificationWithIcon(res.message)
      }
    })
  },
  methods: {
    handleChange (value, event) { // 省选择
      this.provinName = value
      this.provinCode = event.data.attrs.cityCode
      let data = {
        cityScope: 'city',
        cityCode: event.data.attrs.cityCode
      }
      SsoGetCityInfo(data).then((res) => {
        if (res.code === '200') {
          this.cityName = res.data[0].cityName
          this.cityedCode = res.data[0].citydCode
          this.cityArray = res.data
          let parmas = {
            data: {
              attrs: {
                cityCode: res.data[0].cityCode
              }
            }
          }
          this.cityHandleChange(res.data[0].cityName, parmas)
        } else if (res.code !== '200') {
          openNotificationWithIcon(res.message)
        }
      })
    },
    cityHandleChange (value, event) { // 城市选择
      this.cityName = value
      this.cityedCode = event.data.attrs.cityCode
      let data = {
        cityScope: 'area',
        cityCode: event.data.attrs.cityCode
      }
      SsoGetCityInfo(data).then((res) => {
        if (res.code === '200') {
          this.areaName = res.data[0].cityName
          this.areaCode = res.data[0].cityCode
          this.areaArray = res.data
          const region = {
            provinName: this.provinName,
            cityName: this.cityName,
            areaName: this.areaName,
            provinCode: this.provinCode,
            cityedCode: this.cityedCode,
            areaCode: this.areaCode
          }
          this.$emit('setAddress', region)
        } else if (res.code !== '200') {
          openNotificationWithIcon(res.message)
        }
      })
    },
    areaHandleChange (value, event) { // 区域选择
      this.areaName = value
      this.areaCode = event.data.attrs.cityCode
      const region = {
        provinName: this.provinName,
        cityName: this.cityName,
        areaName: this.areaName,
        provinCode: this.provinCode,
        cityedCode: this.cityedCode,
        areaCode: this.areaCode
      }
      this.$emit('setAddress', region)
    }
  }
}
</script>
<style lang="less" scoped>
</style>
